function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenericBankAccount = function SvgGenericBankAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b9c8f"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.555 11.37a1 1 0 0 0-1.109 0l-5.193 3.462a1 1 0 0 1-.556.168H12v2h1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-1v2h16v-2h-1a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h1v-2h-1.697a1 1 0 0 1-.555-.168l-5.193-3.462zM24 18a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-6zm-6-1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e7ece9"
    }
  }));
};
export default SvgGenericBankAccount;